import { render, staticRenderFns } from "./Elozmenyek.vue?vue&type=template&id=19c7732d&"
import script from "./Elozmenyek.vue?vue&type=script&lang=js&"
export * from "./Elozmenyek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports